import * as actions from './contactTag/actions'
import * as mutations from './contactTag/mutations'
import * as getters from './contactTag/getters'

import { dataProps } from './contactTag/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/contactTag.js